let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bKdog"), load("8eNS3"), load("50LrB"), load("7rEYM"), load("2eiOk")]).then(() => parcelRequire('do0K0'));